import Api from './ApiRequest';

export default {
    getAll: (params) => Api.get('/cent/filters', params),
    getById: (id) => Api.get(`/cent/filter/${id}`),
    save: (entity) => Api.post('/cent/filter', entity),
    update: (id, entity) => Api.put(`/cent/filter/${id}`, entity),
    delete: (id) => Api.delete(`/cent/filter/${id}`),
    search: (searchText, params) => Api.get('/cent/filters/search', {q: searchText, ...params}),
    getResults: (id, params) => Api.get(`/cent/filter/${id}/results`, params)
};